export const environment = {
  production: false,
  serverUrl: 'https://api-management-traveler.azure-api.net',
  defaultLanguage: 'es-ES',
  supportedLanguages: ['en-US', 'es-ES', 'pt-BR'],
  serverToken: '9661843830374df0b4cf7daf42cf6d44',
  serverTokenAuth: 'afc688d87a194ffe81039ade5e6ae0e6',
  keyAccessToken: 'eFBTOFF+U1dHa1NLMTlqellfSlh5S3Ztay1GeXQ1amxSZFZiaGN6bQ==',
  flagToken: 'dev',
  server: {
    spv: {
      url: 'https://api-sandbox.pervolare.com/api',
      urlOld: 'https://api.seguroparaviaje.com',
      token:
        'c3B2LTItUEFnOVRmWjg5UVZqWjVZSDhVWkZoc3RrRHBHbmNkSkNxUUI4R2NTc1NxbXVrYjM0R0RBQVVETDlDNDdGN0Y4bg==',
    },
  },
  assistType: {
    medical: '012am000003Ive2AAC',
    travel: '012am000003Ive3AAC',
  },
};
